<template>
  <div>
    <navbar />
    <section>
    <div class="container-fluid " :class="env=='live'?'container-height':'container-height-staging'">
      <Breadcrumb/>
      <div class="row" v-if="passExpDays && (passExpDays >= 80 && passExpDays < 90) && path !== '/changePassword'">
        <div class="col-md-8 mx-auto">
          <div class="alert alert-info text-center">
            Your password is going to expire in {{90-passExpDays  }} days, Kindly <router-link  to="/changePassword"><u>change your password.</u></router-link>
          </div>
        </div>
      </div>
     <router-view/>
    </div>
    </section>
  </div>  
</template>

<script>
import { mapGetters } from 'vuex';
 import Navbar from '@/components/Navbar';
 import Breadcrumb from '@/components/Breadcrumbs';

 export default {
  name: 'layout',
  components: {   
    Navbar, Breadcrumb,  
  },
  data(){
    return{     
      env:process.env.VUE_APP_ENV,
      passExpDays:this.$store.state.user.passExpDays,
      path: this.$route.fullPath
    }
  },
  computed: {
    ...mapGetters([
      'passExpDays'
    ])
  },
}
</script>

<style>
  .container-height {
    margin-top: 4.5rem !important;
  }
   .container-height-staging {
    margin-top: 6.2rem !important;
  }
</style>